import { render, staticRenderFns } from "./AbsenceUnjustifiedDayLegend.vue?vue&type=template&id=b3987cfc&"
import script from "./AbsenceUnjustifiedDayLegend.vue?vue&type=script&lang=js&"
export * from "./AbsenceUnjustifiedDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports